module.exports = __webpack_public_path__ + "static/media/lcs_60yd_y-1.c9977bd1.csv";